var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnkle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ankle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ankle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80676787,6.72208561 C6.05089561,9.56183805 6.31807757,12.5718005 5.80676787,14.4788312 C5.46589473,15.7501849 4.94590929,17.2543908 4.24681155,18.9914487 C4.00521019,19.9076086 3.85880769,20.5857062 3.80760407,21.0257415 C3.73079864,21.6857944 3.73079864,22.3663971 3.80760407,22.7659236 C3.8844095,23.1654502 4.15811303,23.8341135 5.05781934,24.1914302 C5.95752564,24.5487468 7.10580112,24.6130497 8.27149278,24.5387484 C9.43718443,24.4644472 10.1382754,24.0089143 10.5938574,23.8385626 C11.0494394,23.668211 11.757018,23.4744313 12.7737128,23.4971641 C13.4515094,23.5123193 14.5277926,23.6664308 16.0025623,23.9594987 C18.3394346,24.5993133 20.112906,24.9339829 21.3229767,24.9635073 C22.5330473,24.9930317 23.7594173,24.8056493 25.0020867,24.4013599 C25.2837821,24.3091125 25.4651358,24.2589872 25.5461477,24.250984 C25.6271595,24.2429809 25.7422131,24.2627071 25.8913083,24.3101627 C26.565484,24.4757259 27.1620083,24.336967 27.6808814,23.893886 C28.0111714,23.6118416 28.5111723,23.0424209 28.5690615,22.3769466 C28.5998826,22.0226383 28.5653917,21.6657491 28.4655886,21.306279 C27.8262585,21.2502385 27.3595188,21.2185969 27.0653696,21.2113542 C26.7712203,21.2041116 26.5393759,21.2185525 26.3698362,21.2546768 C25.9695648,21.1224017 25.572001,21.04609 25.1771449,21.0257415 C24.5848607,20.9952188 24.0566544,21.0391778 23.7173573,21.0257415 C23.4911591,21.016784 23.2527954,20.9773451 23.0022661,20.9074248 C22.2576368,20.3527554 21.6978737,19.9725457 21.3229767,19.7667959 C20.521275,19.3268082 19.0891917,18.7961841 15.811104,16.9267874 C15.01573,16.4732091 14.082741,15.615409 13.7346491,14.8446009 C13.3865572,14.0737928 13.2813081,12.4747537 13.2813081,11.2478188 C13.2813081,10.4298622 13.3833623,9.34725593 13.5874705,8 L15.811104,-3.5 L4.84304753,-3.5 C5.32277593,1.42155545 5.64401604,4.82891732 5.80676787,6.72208561 Z",
    id: "background",
    fill: "#8596A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8466726,21.9451631 C27.5896108,22.0396257 28.1292495,21.8266643 28.4655886,21.306279 C27.8262585,21.2502385 27.3595188,21.2185969 27.0653696,21.2113542 C26.7712203,21.2041116 26.5393759,21.2185525 26.3698362,21.2546768 C26.2829645,21.5656935 26.4419099,21.7958555 26.8466726,21.9451631 Z",
    id: "background",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "4.31983777 18.1822669 13.672894 14.0173583 14.3407506 15.6321233 3.75 20.3560115"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "14.2146558 15.2471407 16.164985 16.9326958 12.7737128 23.4971641 9.749091 24.3752643"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "13.672894 14.0173583 13.4844756 12.5378868 5.62409206 15.2471407 4.55329038 17.8944473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "11.8176073 23.6636234 5.41225606 15.2471407 4.55329038 17.8944473 9.3467821 24.571126"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "5.41225606 15.2471407 5.89402931 12.5998341 13.4844756 11.0557882 13.4844756 12.5378868"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkle);
export default __webpack_public_path__ + "static/media/Ankle.d25bafcca9d344470e4d7fedbcf0ce29.svg";
export { ForwardRef as ReactComponent };